/** Virtual node — not a real group; roster is derived from person links on students. */

export const DERIVED_GUARDIANS_GROUP_ID = '__derived_guardians__';
export const DERIVED_GUARDIANS_ID_PREFIX = '__derived_guardians__:';

export const DERIVED_GUARDIANS_GROUP = Object.freeze({
  id: DERIVED_GUARDIANS_GROUP_ID,
  name: 'Guardians',
  group_type: 'derived',
  description: 'Parents and guardians linked to enrolled students',
  is_derived: true,
  periods: []
});

export function derivedGuardiansGroupId(parentGpId) {
  if (!parentGpId) return DERIVED_GUARDIANS_GROUP_ID;
  return `${DERIVED_GUARDIANS_ID_PREFIX}${parentGpId}`;
}

export function getDerivedGuardiansParentGpId(groupOrId) {
  const id =
    typeof groupOrId === 'object' && groupOrId != null ? groupOrId.id : groupOrId;
  const s = String(id || '');
  if (s.startsWith(DERIVED_GUARDIANS_ID_PREFIX)) {
    return s.slice(DERIVED_GUARDIANS_ID_PREFIX.length) || null;
  }
  if (typeof groupOrId === 'object' && groupOrId?.parent_groups_periods_id) {
    return String(groupOrId.parent_groups_periods_id);
  }
  return null;
}

export function isDerivedGuardiansGroup(groupOrId) {
  const id =
    typeof groupOrId === 'object' && groupOrId != null ? groupOrId.id : groupOrId;
  const s = String(id || '');
  return s === DERIVED_GUARDIANS_GROUP_ID || s.startsWith(DERIVED_GUARDIANS_ID_PREFIX);
}

export function buildDerivedGuardiansGroup(parentGpId) {
  return {
    ...DERIVED_GUARDIANS_GROUP,
    id: derivedGuardiansGroupId(parentGpId),
    parent_groups_periods_id: parentGpId || null,
    is_derived: true
  };
}

export function buildDerivedGuardiansWebNode(parentGpId) {
  const group = buildDerivedGuardiansGroup(parentGpId);
  return {
    nodeType: 'group',
    id: `group-${group.id}`,
    group,
    isDerivedGuardians: true,
    derivedParentGpId: parentGpId || null
  };
}

/** Normalize API placement list to a Set of parent GP id strings. */
export function toDerivedParentGpIdSet(placementParentGpIds) {
  if (!placementParentGpIds) return new Set();
  if (placementParentGpIds instanceof Set) return placementParentGpIds;
  return new Set(
    (Array.isArray(placementParentGpIds) ? placementParentGpIds : [])
      .filter(Boolean)
      .map(String)
  );
}
